'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _url = require('./geos/url');

var _url2 = _interopRequireDefault(_url);

var _cache = require('./geos/cache');

var _cache2 = _interopRequireDefault(_cache);

var _dp = require('./city/dp.js');

var _dp2 = _interopRequireDefault(_dp);

var _mt = require('./city/mt.js');

var _mt2 = _interopRequireDefault(_mt);

var _log = require('./log');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Promise = window.Promise || require('promise');

var GEOS = [_url2.default, _cache2.default, require("./geos/app"), require("./geos/weixin"), require("./geos/mobileqq"), require("./geos/x5"), // （TBS）补位API
require("./geos/qqbrowser"), // 1.浏览器 2.安卓微信&QQ补位API
require("./geos/html") // 兜底
];
var DIANPING = 'dianping';
var MEITUAN = 'meituan';

var Whereami = function () {
    function Whereami() {
        _classCallCheck(this, Whereami);

        this.isLocating = false;
        this.sucCallbackQueue = [];
        this.errorCallBackQueue = [];
    }

    _createClass(Whereami, [{
        key: 'initData',
        value: function initData() {
            // config
            this.timeout = _config2.default.get('timeout') || 10000;
            this.disables = _config2.default.get('disables') || [];
            this.needCity = _config2.default.get('city');
            this.cityType = _config2.default.get('cityType');
            this.allowCache = !~this.disables.indexOf('cache'); // 说明：默认使用内存，只有`disables`能完全屏蔽`cache`API
            this.debug = /debug:whereami/i.test(location.href) || _config2.default.get('debug');

            this.apiTimeout = this.timeout; // 说明：目前统一设置为业务允许的最大值，灵活可控，组件内保留缓存策略

            // once
            this.isTimeout = false;
            this.timer = undefined;
            this.current = -1;
            this.onceStartTime = Date.now(); // 一次调用的开始时间
            (0, _log.LogClean)(); // 根据采样率重置上报开关
        }
    }, {
        key: 'action',
        value: function action(onSucc, onFail) {
            var _this = this;

            // 预处理
            onSucc = typeof onSucc == 'function' ? onSucc : this.noop;
            onFail = typeof onFail == 'function' ? onFail : this.noop;
            // 过滤爬虫
            if (this.isSpider()) return onFail();

            // 回调队列
            this.sucCallbackQueue.push(onSucc);
            this.errorCallBackQueue.push(onFail);

            // 检查状态: 业务并发调用控制阀
            if (this.isLocating) return;
            this.isLocating = true;
            // 初始化数据
            this.initData();
            // 计时器
            this.timer = setTimeout(function () {
                _this.isTimeout = true;
                // GEO总体上报: 一次定位结束[3]
                (0, _log.Log)(_this.onceStartTime, 408); // 若全量使用缓存策略，统计数据GEO满足`408=201+409+416`等式
                // 业务回调
                _this.execute(_this.errorCallBackQueue, {
                    code: 202,
                    message: 'Timeout: ' + _this.timeout + 'ms'
                });
            }, this.timeout);

            // 开始定位
            this.next();
        }

        /**
         * 定位流程处理策略
         * 1.已超时，允许缓存: 业务方返回失败结果，组件内部继续定位（补位API逆袭; 阶段二城市信息）
         * 2.已超时，禁止缓存: API定位结束（结果无增益）
         * 3.未超时，GEO API依次调用（正常流程）
         */

    }, {
        key: 'processOn',
        value: function processOn() {
            return !this.isTimeout || this.allowCache;
        }

        /**
         * 调用场景：
         * 1. 显式调用: 开始定位、禁用、环境不支持(匹配UA)或业务不支持(`enables`选项且未显式声明)
         * 2. 隐式调用: API异常、`enables`定位失败、超时 [新增]
         * 3. 隐式调用: 定位结果无效 [新增]
         */

    }, {
        key: 'next',
        value: function next() {
            var _this2 = this;

            // API队列计数器
            this.current++;
            // 队列结束
            if (!GEOS[this.current]) {
                // GEO总体上报: 一次定位结束[4]
                (0, _log.Log)(this.onceStartTime, this.isTimeout ? 416 : 417);
                // 超时
                if (this.isTimeout) return;
                clearTimeout(this.timer);
                // 业务回调
                return this.execute(this.errorCallBackQueue, {
                    code: '204',
                    message: 'No Geo Support'
                });
            }

            // 流程策略检查
            if (!this.processOn()) return;

            // API调用描述信息（闭包）
            var geoMethodType = GEOS[this.current].type;
            var startTime = Date.now();
            // API禁用（高优先级）
            if (~this.disables.indexOf(geoMethodType)) {
                return this.next();
            }
            // Debug
            this.debug && alert('start geos: ' + geoMethodType);
            // console.log('WhereAmI Geo Channel:', geoMethodType);

            GEOS[this.current](function (ret, token) {
                _this2.geoSuccHandle(ret, {
                    customToken: token,
                    originToken: startTime,
                    geoMethodType: geoMethodType, // 备选
                    startTime: startTime
                });
            }, function (err, token) {
                _this2.geoErrorHandle(err, {
                    customToken: token,
                    originToken: startTime,
                    geoMethodType: geoMethodType, // 备选
                    startTime: startTime
                });
            }, this.next.bind(this), {
                token: startTime, // 分发Token
                timeout: this.apiTimeout // API超时时长
            });
        }

        /**
         * API 回调时效性校验，确保回调(succ、fail)有且仅有一次生效
         * @param custom API当前Token(分发至API，各自`keeper`实例管理，只读一次、超时销毁)
         * @param origin 原始Token
         */

    }, {
        key: 'validToken',
        value: function validToken(custom, origin, geoMethodType) {
            try {
                if (!origin || !custom) return false;
                return new Date(origin).toString() == new Date(custom).toString();
            } catch (e) {
                return false;
            }
        }

        /**
         * API定位结果校验
         * @param ret 
         */

    }, {
        key: 'validGeoRet',
        value: function validGeoRet(ret) {
            return !!(ret && parseFloat(ret.lat) && parseFloat(ret.lng));
        }

        /**
         * API定位成功（未校验）: Token校验、数据校验、API上报、[GEO上报, 补位API调用]，不涉及业务回调
         * @param ret 
         * @param param1 
         */

    }, {
        key: 'geoSuccHandle',
        value: function geoSuccHandle(ret, _ref) {
            var customToken = _ref.customToken,
                originToken = _ref.originToken,
                geoMethodType = _ref.geoMethodType,
                startTime = _ref.startTime;

            // 校验token
            if (!this.validToken(customToken, originToken, geoMethodType)) {
                this.allowCache && _cache2.default.set(ret); // 说明: API超时时长以业务为准，允许组件写入缓存；其他情况不追加结果
                return;
            }
            // API信息
            var geoType = ret.type || geoMethodType;
            // 校验数据
            var validRet = this.validGeoRet(ret);
            // API定位上报
            (0, _log.Log)(startTime, validRet || 206, geoType);
            if (!validRet) {
                return this.next(); // 补位API继续定位，提升总体成功率（代价是平均时延增大）
            }
            // GEO总体上报: 一次定位结束[1]
            (0, _log.Log)(this.onceStartTime, !this.isTimeout || 201);
            (0, _log.LogService)(this.onceStartTime, ret);
            // 组件业务逻辑处理
            this.getPositionSuccess(ret, geoType);
        }

        /**
         * API定位失败、异常、超时: Token校验、API上报、[GEO上报, 补位策略]，不涉及业务回调
         * @param err 
         * @param param1
         */

    }, {
        key: 'geoErrorHandle',
        value: function geoErrorHandle() {
            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref2 = arguments[1];
            var customToken = _ref2.customToken,
                originToken = _ref2.originToken,
                geoMethodType = _ref2.geoMethodType,
                startTime = _ref2.startTime;

            // 校验token
            if (!this.validToken(customToken, originToken, geoMethodType)) return;
            // API信息
            var geoType = err.type || geoMethodType;
            // API定位上报
            (0, _log.Log)(startTime, err.code, geoType);
            if (~[400, 404, 407, 408, 412].indexOf(err.code)) {
                if (err.code == 400) {
                    // 异常详情上报
                    (0, _log.LogError)(err, geoType, err.title || geoType + '-exception');
                } else if (err.code == 404) {
                    // `enables`API定位失败详情上报
                    (0, _log.LogError)(err, geoType);
                }
                // 407: 设备未授权
                // 408: API超时
                // 412: 未命中
                return this.next(); // 使用补位API继续定位
            }
            // 401: `用户未授权`进入结束状态 -> 1) 用户不友好 2) 反馈至业务方（主要是html渠道）
            // GEO总体上报: 一次定位结束[2]
            (0, _log.Log)(this.onceStartTime, this.isTimeout && 409);
            // 错误详情上报
            (0, _log.LogError)(err, geoType);

            // 组件业务逻辑处理
            this.getPositionError(err);
        }

        /**
         * 定位成功后的业务流程: 数据处理、缓存、城市、超时处理、回调队列
         * @param ret 
         * @param geoMethodType 
         */

    }, {
        key: 'getPositionSuccess',
        value: function getPositionSuccess(ret, geoMethodType) {
            var _this3 = this;

            // 策略检查 (阶段1)
            if (!this.processOn()) return;

            // 数据处理
            ret.geoType || (ret.geoType = 'wgs84'); // 坐标系类型
            ret.type || (ret.type = geoMethodType); // 定位API类型
            // 缓存1: 经纬度
            this.allowCache && _cache2.default.set(ret);

            // 城市接口
            this.needCity = this.needCity && (!ret.city || ret.city.cityType !== this.cityType);
            var _cityStartTime = Date.now();
            Promise.resolve(this.needCity && this.getCity(ret)).then(function (city) {
                // 城市接口统计，与业务超时无关
                city && (0, _log.Log)(_cityStartTime, true, null, 'city-' + _this3.cityType);
                // 策略检查 (阶段2, 可能是异步)
                if (!_this3.processOn()) return;
                // 计时清零
                clearTimeout(_this3.timer);
                // 城市数据处理、缓存、上报
                if (city) {
                    try {
                        ret.city = typeof city == 'string' && JSON.parse(city) || city;
                        // 缓存2
                        _this3.allowCache && _cache2.default.set(ret);
                    } catch (e) {}
                }
                // 消费回调队列
                _this3.isTimeout || _this3.execute(_this3.sucCallbackQueue, ret);
            }).catch(function () {
                var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                // 计时清零
                clearTimeout(_this3.timer);
                // 城市接口成功率统计
                (0, _log.Log)(_cityStartTime, err.code, null, 'city-' + _this3.cityType);
                // 消费回调队列: 包装code、message传给调用方
                _this3.isTimeout || _this3.execute(_this3.errorCallBackQueue, {
                    code: 207,
                    message: err.message
                });
            });

            // debug
            this.debug && alert(JSON.stringify(ret));
            console.log('succ channel:' + geoMethodType);
        }

        /**
         * 定位失败后的业务处理流程: 超时处理、回调队列
         * @param err 
         * @param geoMethodType 
         */

    }, {
        key: 'getPositionError',
        value: function getPositionError() {
            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var geoMethodType = arguments[1];

            // 超时
            if (this.isTimeout) return;
            // 计时清零
            clearTimeout(this.timer);
            // 业务回调
            this.execute(this.errorCallBackQueue, _extends(err, {
                code: '205' // 默认状态码
            }));
        }

        /**
         * 根据`cityType`选取城市接口
         * @param ret 定位结果
         */

    }, {
        key: 'getCity',
        value: function getCity(ret) {
            var useMeituan = void 0;
            if (this.cityType == DIANPING) {
                useMeituan = false; // 显式设置优先于默认设置
            } else if (this.cityType == MEITUAN || /.meituan.(com|net)$/.test(location.hostname)) {
                this.cityType = MEITUAN;
                useMeituan = true;
            } else {
                this.cityType = DIANPING; // 默认用`点评`
            }
            var method = useMeituan ? _mt2.default : _dp2.default;
            return method(ret, {
                token: Date.now(), // 暂时不做校验
                timeout: this.apiTimeout
            });
        }

        /**
         * 消费回调队列 -> 收尾
         * @param queue 
         * @param args 
         */

    }, {
        key: 'execute',
        value: function execute(queue) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            for (var i = 0, l = queue.length; i < l; i++) {
                try {
                    queue.shift().apply(null, args);
                } catch (e) {}
            }
            this.endHandle();
        }

        /**
         * 一次(批)调用最后一步: 清空回调队列，打开组件定位开关
         */

    }, {
        key: 'endHandle',
        value: function endHandle() {
            this.isLocating = false;
            this.sucCallbackQueue = [];
            this.errorCallBackQueue = [];
        }
    }, {
        key: 'isSpider',
        value: function isSpider() {
            return !!navigator.userAgent.match(/spider/i);
        }
    }, {
        key: 'noop',
        value: function noop() {}
    }]);

    return Whereami;
}();

var instance = new Whereami();

module.exports = instance.action.bind(instance);
module.exports.cache = _cache2.default.syncAPI;
module.exports.url = _url2.default.syncAPI;
module.exports.config = _config2.default.config;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/index.js
// module id = 410
// module chunks = 10 11 12 13 14